import { usePastShiftParticipantsByShiftId, } from '../../../../ui/features/shift/hooks/usePastShiftParticipantsByShiftId';
export const useShiftParticipantsTableDataProvider = (request, additionalData) => {
    var _a, _b;
    const { shiftId } = additionalData;
    const { participants, fetchParticipants, total: totalShifts, isLoading, error, } = usePastShiftParticipantsByShiftId({
        shiftId,
        offset: (_a = request === null || request === void 0 ? void 0 : request.offset) !== null && _a !== void 0 ? _a : 0,
        limit: (_b = request === null || request === void 0 ? void 0 : request.limit) !== null && _b !== void 0 ? _b : 5,
    });
    const data = {
        filteredRowCount: totalShifts !== null && totalShifts !== void 0 ? totalShifts : 0,
        rows: participants !== null && participants !== void 0 ? participants : [],
    };
    return {
        data,
        error,
        isLoading,
        reload: fetchParticipants,
        customBackendResponseData: {
            mutate: fetchParticipants,
        },
    };
};
